import { Component } from '@angular/core';

@Component({
  templateUrl: './order-details-page.component.html'
})
export class OrderDetailsPageComponent {}
